import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FeatureFlagsService } from '@wilson/feature-flags';
import { Observable } from 'rxjs';

const SHIFT_REPORT_CLIENT_COMMENT_FEATURE_FLAG = 'shift-report-client-comment';

/**
 * Single source of truth for whether the shift client comments feature is
 * enabled for the current user. Drawers use this instead of re-evaluating the
 * `shift-report-client-comment` flag themselves.
 */
@Injectable({ providedIn: 'root' })
export class ShiftClientCommentsFeatureService {
  private readonly featureFlagsService = inject(FeatureFlagsService);

  /** Whether the shift client comments feature is currently enabled. */
  readonly isEnabledSignal = computed(
    () =>
      !!this.featureFlagsService.flagSignal()?.[
        SHIFT_REPORT_CLIENT_COMMENT_FEATURE_FLAG
      ],
  );

  /**
   * Observable mirror of {@link isEnabledSignal}. Emits the current value
   * immediately and re-emits only when the flag actually changes, so a drawer
   * can re-fetch a shift with the right relations before rendering the section.
   */
  readonly isEnabled$: Observable<boolean> = toObservable(this.isEnabledSignal);
}
